export const SCROLLBAR_WIDTH = 10
